import type {
  CourierChatStateResponse,
  CourierChatUrlParams,
  CourierChatUrlResponse,
  HelpCenterChatStateResponse,
  HelpCenterUrlParams,
  HelpCenterUrlResponse,
} from '../entities'
import {
  CourierChatStateResponseSchema,
  CourierChatUrlResponseSchema,
  HelpCenterChatStateResponseSchema,
  HelpCenterUrlResponseSchema,
} from '../entities'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'

export const getHelpCenterUrl = async ({
  orderId,
  userId,
  countryCode,
}: HelpCenterUrlParams = {}): Promise<HelpCenterUrlResponse> => {
  // userId and country code are not expected by the API, but are sent to invalidate browser cache, the API takes its values from the headers.
  const { apiUrl } = getConfig()
  const cacheBust = `${userId ?? '-'}_${countryCode ?? '-'}`
  const url = orderId
    ? `${apiUrl}/v1/help_center/init?orderId=${orderId}&bridge=true&cacheBust=${cacheBust}`
    : `${apiUrl}/v1/help_center/init?bridge=true&cacheBust=${cacheBust}`
  const response = await fetcher.get<HelpCenterUrlResponse>(url)
  const helpCenterUrl = HelpCenterUrlResponseSchema.parse(response.data)
  return helpCenterUrl
}

export const getHelpCenterChatState = async (): Promise<HelpCenterChatStateResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get<HelpCenterChatStateResponse>(
    `${apiUrl}/v1/help_center/chat/unread-message-count`
  )
  const chatState = HelpCenterChatStateResponseSchema.parse(response.data)
  return chatState
}

export const getCourierChatUrl = async ({
  orderId,
}: CourierChatUrlParams = {}): Promise<CourierChatUrlResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get<CourierChatUrlResponse>(
    `${apiUrl}/v1/help_center/chat/rider/init?orderId=${orderId}&bridge=true`
  )
  const chatUrl = CourierChatUrlResponseSchema.parse(response.data)
  return chatUrl
}

export const getCourierChatState = async (): Promise<CourierChatStateResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get<CourierChatStateResponse>(
    `${apiUrl}/v1/help_center/chat/rider/status`
  )
  const chatState = CourierChatStateResponseSchema.parse(response.data)
  return chatState
}
